import VaccineRecordErrorModalView from 'components/Vaccines/VaccineRecordErrorModalView';
import { clearSaveError } from '@spike/pets-action';
import { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectVaccineRecordSaveError } from './selectors';

interface Props {
    // Optional extra behavior for the mount point, e.g. returning focus to the
    // vaccine upload field. The modal always clears the error state itself.
    onCancel?: () => void;
    onUploadAgain?: () => void;
}

/**
 * Binds the shared vaccine-record error modal to the pets slice, for the flows
 * that save through `saveMedicalHistoryThunk`.
 */
export const VaccineRecordErrorModal: FunctionComponent<Props> = props => {
    const dispatch = useDispatch();
    const saveError = useSelector(selectVaccineRecordSaveError);

    if (!saveError) {
        return null;
    }

    const cancelHandler = () => {
        dispatch(clearSaveError());
        props.onCancel && props.onCancel();
    };

    const uploadAgainHandler = () => {
        dispatch(clearSaveError());
        props.onUploadAgain && props.onUploadAgain();
    };

    return (
        <VaccineRecordErrorModalView
            variant={saveError.variant}
            onCancel={cancelHandler}
            onUploadAgain={uploadAgainHandler}
        />
    );
};

export default VaccineRecordErrorModal;
